var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("delegation-rate-menu"),
      _c(
        "v-alert",
        { attrs: { value: _vm.groups.length === 0, type: "info" } },
        [
          _vm._v(
            _vm._s(
              _vm.$t(
                "settings.delegationRate.customDelegationRate.noCustomGroups"
              )
            ) + " "
          )
        ]
      ),
      _c(
        "v-expansion-panels",
        { attrs: { multiple: "", accordion: "" } },
        _vm._l(_vm.groups, function(item) {
          return _c(
            "v-expansion-panel",
            { key: item.id, attrs: { lazy: true } },
            [
              _c(
                "v-expansion-panel-header",
                { staticStyle: { "border-bottom": "blue 1px" } },
                [
                  _c("h3", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(
                            "settings.delegationRate.customDelegationRate.ratesForGroup"
                          )
                        ) +
                        " "
                    ),
                    _c("b", [_vm._v(_vm._s(item.name))])
                  ]),
                  _vm._v(
                    " (" +
                      _vm._s(item.count_rates) +
                      " " +
                      _vm._s(
                        _vm.$t(
                          "settings.delegationRate.customDelegationRate.specialRates"
                        )
                      ) +
                      ", " +
                      _vm._s(item.count_users) +
                      " " +
                      _vm._s(
                        _vm.$t(
                          "settings.delegationRate.customDelegationRate.users"
                        )
                      ) +
                      " " +
                      _vm._s(
                        item.child_group_names != null
                          ? ", " +
                              _vm.$t(
                                "settings.delegationRate.customDelegationRate.childGroups"
                              ) +
                              ": " +
                              item.child_group_names
                          : ""
                      ) +
                      ") "
                  )
                ]
              ),
              _c(
                "v-expansion-panel-content",
                { staticClass: "grey lighten-4 pa-3" },
                [
                  _c("custom-delegation-rate-content", {
                    attrs: { id: item.id }
                  })
                ],
                1
              )
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }